import { envSchema } from "@/utils/env-schema";

// Should **only** be used once during app-startup / initialization
export function initializeEnv() {
  return envSchema.parse(import.meta.env);
}

/**
 * @deprecated Use env created at startup (see how `initializeEnv()` value is passed down and used)
 * Or have your service be initialized at app startup where an 'env' is available (in di.ts or above)
 */
export const deprecatedEnv = initializeEnv();
